import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Theme-injection-proof keyboard badge.
 *
 * Chakra UI v2's global theme wrapper applies `!important` to all token values,
 * which overrides the `Kbd` component's `color` and makes glyphs invisible.
 * This component renders a native <kbd> element with explicit inline styles
 * that cannot be overridden by any CSS-in-JS theme injection.
 */
export function PaletteKbd({ children }) {
    return (_jsx("kbd", { style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
            fontSize: '0.65rem',
            lineHeight: 1,
            color: '#4A5568', // neutral.700 equivalent
            background: '#F7FAFC', // neutral.50 equivalent
            border: '1px solid #E2E8F0', // neutral.200
            borderBottomWidth: '2px', // key depth effect
            borderRadius: '4px',
            padding: '2px 5px',
            minWidth: '18px',
            whiteSpace: 'nowrap'
        }, children: children }));
}
